import { useContext } from 'react';
import { HighlySensitivePropertyContext } from './HighlySensitivePropertyContext';
export const useUpdateHighlySensitivePropertyValues = () => {
  const context = useContext(HighlySensitivePropertyContext);
  if (!context) {
    throw new Error('useUpdateHighlySensitivePropertyValues must be used within a HighlySensitivePropertyContextProvider');
  }
  return context.updateHighlySensitivePropertyValues;
};